"use strict";

$(".toggle-mobile-menu").on("click", function (event) {
    event.preventDefault();
    event.stopPropagation();

    $(this).toggleClass("is-active");
    $("#main-navigation").toggleClass("open");
});

// auto switch to nav tabs
if (window.location.hash) {
    let navMenuItem = $("a.nav-link[data-target='" + window.location.hash + "']");
    if (navMenuItem.length > 0) {
        window.setTimeout(function() {
            navMenuItem[0].click();
        }, 1);
    }
}

// remove action results
//$("a[data-toggle=tab]").on("show.bs.tab", function() {
//    $("#action-results").remove();
//});
